export * from "./useProductPromotionalOffersQuery";
